// extracted by mini-css-extract-plugin
export default {"row":"_JavMucHde_7sVi7mKpD"};